import { useEffect } from "react";
import { Link, useSearchParams } from "react-router-dom";
import ActionBar from "../components/actionBar/ActionBar";
import FilterDropdown from "../components/filterDropdown/FilterDropdown";
import { SearchFilter } from "../components/filterDropdown/SearchFilter";
import PercentageDial from "../components/percentageDial/PercentageDial";
import { useDevices } from "../hooks/useDevices";
import strings from "../i18n/i18nStrings";
import { DEVICE_ONLINE_STATES, getDeviceOnlineState } from "../utils/devices";
import DevicesTable from "../components/Devices/DevicesTable";

const DashboardPage = () => {
  const [searchParams] = useSearchParams();
  const location_id = searchParams.get("location");

  const { devices, filters, updateFilter, mutate } = useDevices({
    location_id: location_id || null,
    has_battery: null,
    has_water: null,
    is_online: null,
    sort: "name|asc",
  });

  useEffect(() => {
    const interval = setInterval(() => {
      mutate();
    }, 60000); // 60000 milliseconds = 1 minute

    return () => clearInterval(interval); // Cleanup interval on component unmount
  }, [mutate]);

  return (
    <>
      {/* Stats */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-3 mb-3 text-sm">
        <PercentageDial
          title={strings.dashboard.devicesOnline}
          amount={
            devices.filter(
              (device) =>
                device?.last_event_updated_at &&
                getDeviceOnlineState(device?.last_event_updated_at) !==
                  DEVICE_ONLINE_STATES.OFFLINE
            ).length || 0
          }
          totalAmount={devices.length || 0}
        />
        <PercentageDial
          title={strings.dashboard.water_percentage}
          amount={
            devices.reduce(
              (accumulator, currentValue) =>
                accumulator + (currentValue.water_percentage || 0),
              0
            ) / devices.length || 0
          }
        />
        <PercentageDial
          title={strings.dashboard.batteryLevel}
          amount={
            devices.reduce(
              (accumulator, currentValue) =>
                accumulator + (currentValue.battery_percentage || 0),
              0
            ) / devices.length || 0
          }
        />
      </div>

      {/* Devices Table */}
      <div className="bg-white shadow rounded-lg mb-14 overflow-x-auto">
        {/* <div>{JSON.stringify(user)}</div> */}
        <DevicesTable
          devices={devices}
          updateFilter={updateFilter}
          filters={filters}
        />
      </div>
      <ActionBar>
        <FilterDropdown updateFilter={updateFilter} />
        <SearchFilter onChange={(value) => updateFilter({ search: value })} />

        <Link
          to="/devices?add=true"
          className={`ml-auto px-4 py-3 border border-transparent rounded-md shadow-sm text-xs font-bold uppercase tracking-wider text-white ${
            // users.length >= 5
            // ? "bg-gray-300 cursor-not-allowed"
            // :
            "bg-blue-700 hover:bg-blue-800"
          }`}
        >
          {strings.deviceSettings.getMoreDevices}
        </Link>
      </ActionBar>
    </>
  );
};

export default DashboardPage;
